<template>
  <div class="contact u-pad-x-1of12 u-pad-y-xl u-pad-y-md--sm">
    <div class="contact__container u-row u-bg-white u-radius">
      <div class="u-w5of12 u-w12of12--sm">
        <h3 class="t-text u-blue">
          CONTACTS
        </h3>
        <div class="u-marg-t-sm u-pad-t-xs">
          <a class="t-text" href="mailto:contact@brig.ht">
            contact@brig.ht
          </a>
        </div>
        <div class="u-marg-t-sm u-pad-t-xs">
          <a class="t-text" href="tel:0176410949">
            +33 1 76 41 09 49
          </a>
        </div>
        <social-media class="u-marg-t-sm u-pad-t-xs u-row u-top"/>
      </div>
      <div class="u-w7of12 u-w12of12--sm">
        <div class="t-text u-blue u-marg-t-lg--sm">
          ENTRONS EN CONTACT
        </div>
        <div class="t-h3 u-blue u-marg-t-sm u-pad-t-xs">
          Un projet ?
        </div>
        <div class="t-h3 u-blue u-marg-t-sm u-pad-t-xs u-pad-t-sm--sm u-center--sm">
          <app-button :to="{...$local('SimplePage'), params: {slug: contact.slug }}" :isSmall="true">
            <span class="t-text--xsmall">
              Nous contacter
            </span>
          </app-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/common/AppButton'
import SocialMedia from './SocialMedia.vue'

export default {
  computed: {
    contact () {
      return this.$store.getters['data/contact'][0]
    }
  },

  components: {
    AppButton,
    SocialMedia
  }
}
</script>

<style lang="stylus">
.contact
  &__container
    padding 40px 50px
</style>